export default __webpack_public_path__ + "static/media/app_store_ja_dark.8f59c072.svg";